import { useResultMediaQuery } from "@/hooks/useResultMediaQuery"

const hooks = { useResultMediaQuery }

export default hooks
